<script lang="ts" setup>
import { onMounted } from '#imports';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import ArrowBtnIcon from '~/assets/image/index/arrow-btn.svg';
import ModuleTitle from '../ModuleTitle.vue';
import ContestItem from './ContestItem.vue';
import { HotContestsService } from './HotContests.service';

declareProviders([HotContestsService]);
const service = useService(HotContestsService);

onMounted(() => {
  service.init();
});
</script>

<template>
  <div
    v-if="service.hotContests.length"
    class="hot-contest rounded border border-lightblack bg-white p-3"
  >
    <div class="mb-[14px] mt-[2px] flex items-center">
      <ModuleTitle>
        <img src="~/assets/image/index/title/rmss.svg" alt="热门赛事" />
      </ModuleTitle>
      <NuxtLink
        class="ml-auto flex items-center"
        :to="{
          name: 'oj_contest',
        }"
        ><span class="text-xs text-font2">查看更多</span
        ><img class="ml-1 w-4" :src="ArrowBtnIcon"
      /></NuxtLink>
    </div>
    <a-skeleton v-if="service.loading" />
    <ul class="flex gap-3">
      <ContestItem
        v-for="contest in service.hotContests"
        :key="contest.id"
        v-track:newoj_homepage_popularcontest_show="{ contest_id: contest.id }"
        v-track:newoj_homepage_popularcontest_click.click="{
          contest_id: contest.id,
        }"
        :contest-id="contest.id"
        :title="contest.title"
        :status="contest.status"
        :registered="contest.registered"
        :owner-vo="contest.ownerVo"
        :type-desc="contest.typeDesc"
        :match-type-desc="contest.matchTypeDesc"
        :start-time="contest.startTime"
        :end-time="contest.endTime"
        :avatar-list="contest.avatarList"
        :count="contest.count"
      />
    </ul>
  </div>
</template>
